import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'
import { OrderFrom } from '@/common/context/orderSourceValues'

/**
 * Props for BuyOrderSubmitted event.
 *
 * @property request_id - unique request identifier
 * @property security_code - instrument code
 * @property type - order type
 * @property requested_price - computed price/amount
 * @property last_price - last traded price
 * @property number_of_shares - number of shares
 * @property validity - order validity
 * @property order_from - page origin (portfolio, dashboard, find_stocks, campaigns)
 * @property order_entry_point - specific entry action (buy_more, security_link, trending_etf, filters, buy_shares)
 * @property accountId - account the order was placed against
 */
export interface BuyOrderSubmittedProps extends EventProps {
    request_id?: string
    security_code?: string
    type?: string
    requested_price?: number
    last_price?: number
    number_of_shares?: number
    validity?: string | number
    isPledged?: boolean
    has_campaign?: boolean
    ethicalTags?: string[]
    numPositiveTags?: number
    numNegativeTags?: number
    hasSixthSenseProfile?: boolean
    promotionId?: string | number | null
    promotion?: string | null
    order_from?: OrderFrom | null
    order_entry_point?: string | null
    accountId?: string | null
}

/**
 * @event BuyOrderSubmitted
 * @description Emitted when a buy order is submitted from the trade review flow.
 */
export const BuyOrderSubmittedAnalytics = createAnalyticsStatic<BuyOrderSubmittedProps>(
    ANALYTICS_EVENTS.TRADING.BUY_ORDER_SUBMITTED,
)
